import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import { IconButton, TextField, Button } from '@mui/material';
import { useState } from 'react';
import UserIcon from '../../img/UserIcon.png';
import UserInfo from '../../components/UserInfo';
import TempUser from '../../components/TempUser';
import styles from './loggedInHomeComponents.module.css';


const user = new UserInfo(TempUser);



const ProfileSharingComponent = () => {

	const [clicked, setClicked] = useState(false);

	const handleToggle = () => {
		setClicked(prev => !prev);
	};

	const buttonStyle ={
		borderRadius: 0,              
		borderWidth: '4px',           
		borderColor: 'black',         
		color: 'black',
		fontSize:'20px',
		fontWeight:'bold',
		ml: 2,
		display:"flex",
		'&:hover': {
			borderColor: 'black',
			backgroundColor: 'rgba(0,0,0,0.05)', 
		}
	}

	const iconButtonStyle={
		flexDirection:'column',
		height:"5vw",
		width:"5vw", 
		border: '2px solid',
		borderColor: clicked ? '#3377c1' : 'gray',
		color: clicked ? '#3377c1' : 'black',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		'&:hover': {
			borderColor: '#3377c1',
		},
	}

  	return (

    <div className={styles.PSMainBox}>
		{/* This is the header with the User Image and name */}
		<div className={styles.PSHeaderBox}>
			<img src={UserIcon} alt='Loading Error' className={styles.PSUserImage} />
			<div className={styles.PSHeaderTextBox}>
				<div className={styles.PSUserName}>{user._name}</div>
				<div>
					WARNING: You should only share your profile with someone you know or a school you are applying to or connected to.
				</div>
			</div>
		</div>
		  {/* This is the start of the body */}
		<div className={styles.PSBodyBox}>
			{/* This is the left side of the body with the copy link button*/}
			<div className={styles.PSLeftSide}>
				<IconButton  onClick={handleToggle} aria-label="link" sx={iconButtonStyle}>
					<LinkIcon className={styles.PSIconButtonSymbol}/>
					<div className={styles.PSIconButtonText}>
						{clicked ? 'Link Copied':'Copy Link'}
					</div>
				</IconButton>
				<div className={styles.PSLeftSideTextBox}>
					To share your profile with a Profile Planet link, copy and paste the link in an email or text.
				</div>
			</div>
			{/* This is the middle with the lines and the OR text */}
			<div className={styles.PSMiddleBox}>
				<div className={styles.PSTopLine} />
				<div className={styles.PSLineText}>
					OR
				</div>
				<div className={styles.PSBottomLine}/>
			</div>
				{/* This is the Right side of the body with the text input fields */}
		<div className={styles.PSRightSide} >
			<TextField  label="Email Recipients" variant="outlined"/>
			<TextField  label="Email Subject" variant="outlined" />
			<TextField  label="Email Message" variant="outlined" multiline rows={6} />
			<Button variant="outlined" sx={buttonStyle}>Send</Button>
		</div>
		</div>
    </div>
  );
};

export default ProfileSharingComponent;